export class UrlHelper {
    static getUrlParameterByName(name: string): string | null {
        const match = RegExp('[?&]' + name + '=([^&]*)', 'i').exec(window.location.search);

        return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : null;
    }
}
